// @flow
import * as axios from 'axios';
import type { Axios } from 'axios';

export default class AxiosClient {
  buildClient(token?: string): Axios {
    let headers = {
      'Content-Type': 'application/json',
    };

    if (token != null) {
      headers = {
        ...headers,
        'X-CSRF-Token': token,
      };
    }

    return axios.create({
      baseURL: '/api/v2',
      timeout: 60000,
      headers: headers,
    });
  }
}
